import { connect } from 'react-redux';
import { selectUserInfo, selectActiveVenueId } from 'selectors/general';
import { changeActiveVenue } from 'features/App/App.saga';
import VenueSelector from './VenueSelector';

const mapStateToProps = (state, props) => {
  // We check for an activeVenueId being passed as prop, this allows us to use this component as dumb without actually
  // changing the active venue on the dashboard.
  const activeVenueId = props?.activeVenueId || selectActiveVenueId(state);
  const { venuesList } = selectUserInfo(state);

  return {
    activeVenueId,
    venuesList: venuesList.map(({ venueSubtitle, ...rest }) => ({
      ...rest,
      venueSubtitle: venueSubtitle || undefined,
    })),
  };
};

const mapDispatchToProps = {
  changeActiveVenue,
};

export default connect(mapStateToProps, mapDispatchToProps)(VenueSelector);
